<template>
    <div class="bank-card-info">
        <div>
            <div class="shadow">
                <div style="display: flex;align-items: flex-end;">
                    <span class="d-title">银行卡信息</span>
                    <span style="flex: 1;text-align: right;" class="d-edit" @click="isEdit = !isEdit">编辑</span>
                </div>
                <div style="margin-top: 0.2rem;">
                    <div style="background-color: #909399;height: 1px;width: 100%;"></div>
                </div>
                <div style="margin-top: 0.2rem;" id="b-content">
                    <div v-if="!isEdit" style="padding: 0.1rem 0 0.1rem 0;">
                        <el-row type="flex" justify="space-between">
                            <el-col :span="5" class="col">银行卡号:</el-col>
                            <el-col :span="7" class="col-n col">{{ bankCardInfoForm.card }}</el-col>
                            <el-col :span="5" class="col">开户行:</el-col>
                            <el-col :span="7" class="col-n col">{{ bankCardInfoForm.bank }}</el-col>
                        </el-row>
                    </div>
                    <div v-else>
                        <el-form ref="bankCardInfoForm" :model="bankCardInfoForm" label-width="115px" size="medium">
                            <el-form-item label="银行卡号">
                                <el-input type="number" v-model.trim="bankCardInfoForm.card" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="开户行">
                                <el-input v-model.trim="bankCardInfoForm.bank" clearable maxlength="50"
                                    show-word-limit></el-input>
                            </el-form-item>
                            <el-form-item size="medium">
                                <el-button type="primary" @click="onSubmit">提交</el-button>
                                <el-button @click.native="isEdit = !isEdit">取消</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { common } from '../../../../static/mixins/common'
export default {
    name: 'BankCardInfo',
    mixins: [common],
    props: {
        adminuser_id: {
            type: Number
        },
        adminuser_name: {
            type: String
        }
    },
    data() {
        return {
            bankCardInfoForm: {
                card: '',
                bank: '',
            },
            isEdit: false,
            adminuserId: '',
            adminuserName: ''
        }
    },
    methods: {
        onSubmit() {
            this.bankCardInfoForm.admin_user_id = this.adminuserId
            this.$axios.put('api/api3_update_bank_card_info', this.bankCardInfoForm).then(({ data }) => {
                if (data.code === 200) {
                    this.bankCardInfoForm.card = data.data['card']
                    this.bankCardInfoForm.bank = data.data['bank']
                    this.$message.success(data.msg)
                } else {
                    this.$message.error(data.msg)
                }
            }).catch()
        },
        getAdminUserBankCardInfo(admin_user_id) {
            this.resetForm()
            this.ysyMAdminUserBankCardInfoOptions = []
            this.ysyMGetAdminUserWorkInfo(admin_user_id)
        },
        resetForm() {
            this.bankCardInfoForm.card = ''
            this.bankCardInfoForm.bank = ''
        },
    },
    watch: {
        adminuser_id: {
            immediate: true,
            handler(n, o) {
                this.adminuserId = null
                if (n !== o) {
                    this.adminuserId = n
                    this.getAdminUserBankCardInfo(n)
                }
            }
        },
        adminuser_name: {
            immediate: true,
            handler(n, o) {
                if (n !== o) {
                    this.adminuserName = n
                }
            }
        },
        ysyMAdminUserBankCardInfoOptions: {
            handler(n, o) {
                if (n !== o) {
                    if (n) {
                        this.bankCardInfoForm.card = n.card
                        this.bankCardInfoForm.bank = n.bank
                    }
                }
            },
        },
    }
}
</script>

<style scoped>
.d-title {
    font-size: x-large;
    font-weight: bold;
}

.d-edit {
    font-size: medium;
    font-weight: bold;
    color: #409EFF;
    cursor: pointer;
}

/* .col {
    font-size: larger;
    font-weight: bold;
} */

/* .col-n {
    color: slategrey;
} */

#b-content .el-row {
    margin-bottom: 0.6rem;
}

.shadow {
    padding: 0.3rem 0.6rem;
    border: 1px solid #ccc;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, .3);
    margin: 0.2rem;
}

.over-title {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

#b-content>>>.el-form-item {
    width: 45% !important;
    display: inline-block !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/authority/UserInfoTab/BankCardInfo.vue